<template>
  <div class="vx-row" id="gallery">
    <div class="vx-col lg:w-3/4 w-full relative">
      <vs-table :data="actualGalleryDetails" id="gallery-tbl" ref="table">
        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th class="img-col">{{ $t("Image") }}</vs-th>
          <vs-th>{{ $t("Caption") }}</vs-th>
          <vs-th>{{ $t("Priority") }}</vs-th>
          <vs-th>{{ $t("Action") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
            <vs-td class="index-td" :data="data[indextr]" style="width:5%">
              {{ parseInt(indextr) + 1 }}
            </vs-td>
            <vs-td class="image-td" :data="data[indextr].pictureContent">
              <img
                :src="URLS_CONSTANTS.assets + 'Product/' + data[indextr].uri"
                @click.prevent="imgPopup(tr)"
              />
            </vs-td>
            <vs-td class="gal-input">
              {{ tr.alt }}
              <!-- <vs-input class="inputx"
                        v-model="data[indextr].alt"
                        :disabled="!tr.editMode" /> -->
            </vs-td>
            <vs-td
              class="gal-input"
              :data="data[indextr].priority"
              style="width:80px"
            >
              <vs-input
                v-model="data[indextr].priority"
                :name="data[indextr].name"
                v-validate="{ regex: '^([0-9]+)$' }"
                :class="{ 'is-invalid': errors.has(data[indextr].name) }"
                :disabled="!tr.editMode"
              />
            </vs-td>
            <vs-td class="action-td">
              <div
                class="remove-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3"
                @click="removeImage(tr.productId, tr.name)"
              >
                <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                <span class="text-sm font-semibold ml-2">{{
                  $t("Remove")
                }}</span>
              </div>

              <div
                class="edit-btn  p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer"
                @click="editAlt(tr, indextr)"
                v-if="!tr.editMode"
              >
                <feather-icon icon="EditIcon" />
                <span class="text-sm font-semibold ml-2">{{ $t("Edit") }}</span>
              </div>
              <div v-if="tr.editMode" class="flex justify-between">
                <div
                  class="editong-buttons bg_l_green p-2 rounded-lg flex  items-center justify-center text-white cursor-pointer"
                  @click="submitEdit(tr, indextr)"
                >
                  <feather-icon icon="CheckIcon" />
                  <span class="text-sm font-semibold ml-2">{{
                    $t("Submit")
                  }}</span>
                </div>
                <div
                  class="editong-buttons   bg_l_red p-2 rounded-lg flex  items-center justify-center text-white cursor-pointer"
                  @click="cancelEdit(tr, indextr)"
                >
                  <feather-icon icon="XIcon" />
                  <span class="text-sm font-semibold ml-2">{{
                    $t("Cancel")
                  }}</span>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <image-popup
        :show="ImagePopup"
        @finish="onfinish"
        :model="modalModel"
        id="gal-popup"
      ></image-popup>
    </div>

    <div class="vx-col lg:w-1/4 w-full">
      <vx-card>
        <div class="upload-wrapper">
          <my-upload
            field="img"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            @src-file-set="srcFileSet"
            v-model="show"
            :width="600"
            :height="600"
            langType="fa"
            :value.sync="show"
            img-format="jpg"
          ></my-upload>
          <img :src="actualGalleryDetails2.imageContent" />
        </div>
        <a class="img-box" @click.prevent="toggleShow">
          {{ $t("UploadImage")
          }}<i class="material-icons notranslate">
            cloud_upload
          </i>
        </a>
      </vx-card>
    </div>
  </div>
</template>
<style lang="scss">
#gal-popup .vs-popup--content {
  overflow-y: scroll !important;
}
</style>
<script>
import { URLS_CONSTANTS } from "../../../../config";
import myUpload from "vue-image-crop-upload";
import { mapGetters, mapActions } from "vuex";
import ImagePopup from "./ImagePopup.vue";
export default {
  data() {
    return {
      actualGalleryDetails: {},
      actualGalleryDetails2: {},
      show: false,
      imgDataUrl: "",
      editMode: false,
      ImagePopup: false,
      modalModel: {},
      imgName: "",
      URLS_CONSTANTS: URLS_CONSTANTS
    };
  },
  components: {
    "my-upload": myUpload,
    ImagePopup
  },
  computed: {
    ...mapGetters({
      actualGallery: "actualGallery/details"
    }),
    popupActive: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchSingle: "actualGallery/fetchSingle",
      updateActualGallery: "actualGallery/update",
      postImage: "actualGallery/create",
      deleteImage: "actualGallery/remove"
    }),

    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id).then(() => {
        this.actualGalleryDetails = JSON.parse(
          JSON.stringify(this.actualGallery)
        );
      });
    },
    submitEdit(item, index) {
      this.updateActualGallery(item).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000
        });
        this.$validator.reset();
        this.$set(this.actualGalleryDetails[index], "editMode", false);
      });
    },
    editAlt(row, index) {
      this.$set(this.actualGalleryDetails[index], "editMode", true);
    },
    cancelEdit(row, index) {
      this.$set(this.actualGalleryDetails[index], "editMode", false);
    },
    cropSuccess(imgDataUrl, field, jsonData) {
      this.imageContent = imgDataUrl;
      this.actualGalleryDetails2 = {
        productId: this.$route.params.id,
        alt: this.imgName,
        fileContent: imgDataUrl
      };
      this.postImage(this.actualGalleryDetails2).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000
        });
        this.actualGalleryDetails2.imageContent = "";
        this.imageContent = "";
        this.load();
      });
    },
    cropUploadSuccess(jsonData, field) {},
    srcFileSet(fileName, fileType, fileSize) {
      this.imgName = fileName;
    },
    cropUploadFail(status, field) {},
    toggleShow() {
      this.show = !this.show;
    },
    removeImage(productId, name) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.deleteImage({ productId, name }).then(() => {
            this.show = false;
            this.load();
          });
        }
      });
    },
    imgPopup(model) {
      this.ImagePopup = true;
      this.modalModel = model.uri;
    },
    onfinish() {
      this.ImagePopup = false;
    }
  }
};
</script>
